'use client';

import { useState } from 'react';
import { ProductContext, ProductSelectionContext } from './contexts';
import { getCrossSellProducts } from '../utils/product-context-helpers';

export function ProductProvider({
  children,
  productData,
  productReviewData,
  settings,
  bundleData,
  isBundlePage,
  additionalProducts: initialAdditionalProducts = [],
  selectorProducts = [],
  title,
  superscript_title,
  searchParams
}) {
  const staticProductValue = {
    productData,
    settings,
    productReviewData,
    title,
    superscript_title,
    crossSellProducts: getCrossSellProducts(productData),

    // Bundle-only fields; bundle pages still use the shared product fields above.
    isBundlePage,
    bundleData,
    selectorProducts
  };

  return (
    <ProductContext.Provider value={staticProductValue}>
      <ProductSelectionProvider
        searchParams={searchParams}
        initialAdditionalProducts={initialAdditionalProducts}
      >
        {children}
      </ProductSelectionProvider>
    </ProductContext.Provider>
  );
}

function ProductSelectionProvider({
  children,
  searchParams,
  initialAdditionalProducts
}) {
  // `null` means the shopper hasn't picked options yet, so we read from URL params.
  // After they pick options, this override wins until the URL promise changes.
  const [selectedOptionsOverride, setSelectedOptionsOverride] = useState(null);
  const [selectedBundleProduct, setSelectedBundleProduct] = useState(null);

  const [quantity, setQuantity] = useState(1);
  const [additionalProducts, setAdditionalProducts] = useState(
    initialAdditionalProducts
  );

  useResetSelectionOnSearchParamsChange({
    searchParams,
    setSelectedOptionsOverride,
    setSelectedBundleProduct
  });

  const selectionStoreValue = {
    searchParams,
    selectedOptionsOverride,
    setSelectedOptionsOverride,
    selectedBundleProduct,
    setSelectedBundleProduct,
    quantity,
    setQuantity,
    additionalProducts,
    setAdditionalProducts
  };

  return (
    <ProductSelectionContext.Provider value={selectionStoreValue}>
      {children}
    </ProductSelectionContext.Provider>
  );
}

function useResetSelectionOnSearchParamsChange({
  searchParams,
  setSelectedOptionsOverride,
  setSelectedBundleProduct
}) {
  // UpsellToggle uses router.push() to a new variant URL while this provider
  // stays mounted, so we need to re-derive from that URL.
  const [lastSearchParams, setLastSearchParams] = useState(searchParams);

  if (searchParams !== lastSearchParams) {
    setLastSearchParams(searchParams);
    setSelectedOptionsOverride(null);
    setSelectedBundleProduct(null);
  }
}
